import './DimQuantitativeSamplesTable.css';

import React, { useState } from 'react';
import { getDimensionValueName } from '../../components/helper';
import { toLocaleDateTime } from '../../../b2b-common/helpers';
import { renderSampleStatusAndTrend } from '../quant/QuantitativeSamplesTable';
import B2BTableInMemory from '../../../b2b-common/B2BTableInMemory';
import { Add } from '@mui/icons-material';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const DimQuantitativeSamplesTable = ({ areaIndicator, onSampleClick, onNewSample = null }) => {
    const { t } = useB2BTranslation('b2b-plans');

    const [currentDimensionalType, setCurrentDimensionalType] = useState(areaIndicator.indicatorDTO.dimensionalType);

    const headers = [
        { label: t('Sample Date'), align: 'center' },
        { label: t('Dimension'), align: 'left' },
        { label: t('Value'), align: 'center' },
        { label: t('Status'), align: 'center' },
    ];

    const rows = areaIndicator ? areaIndicator.sampleDTOs
        .sort((a, b) => {
            const dateComparison = new Date(a.sampleDate) - new Date(b.sampleDate);
            if (dateComparison !== 0) return dateComparison;
            return a.quantitativeDimensionOrder - b.quantitativeDimensionOrder;
        })
        .map((sample) => ({
            id: sample.sampleId,
            cells: [
                { content: toLocaleDateTime(sample.sampleDate, true), align: 'center' },
                { content: getDimensionValueName(sample.quantitativeDimensionOrder, currentDimensionalType), align: 'left' },
                ...(areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit !== '' ?
                    [{ content: `${sample.quantitativeValue} ${areaIndicator.indicatorDTO.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnit}`, align: 'center' }] :
                    [{ content: `${sample.quantitativeValue}`, align: 'center' }]),
                { content: renderSampleStatusAndTrend(sample), align: 'center' },
            ],
        })) : [];

    const handleRowClick = (row) => {
        if (onSampleClick) {
            onSampleClick(areaIndicator.sampleDTOs.find(sample => sample.sampleId === row.id));
        }
    };

    return (
        <B2BTableInMemory
            headers={headers}
            rows={rows}
            numRows={10}
            className={'dim-quantitative-samples-table'}
            onRowClick={handleRowClick}
            buttons={
                [
                    {
                        label: t('New Dimensional Sample'),
                        icon: <Add />,
                        onClick: onNewSample,
                    }
                ]
            }
        />
    );
}

export default DimQuantitativeSamplesTable;